// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture-list {\n  padding: 20px;\n}\n.title {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 8px 0;\n}\n.img-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n.img-box {\n  width: 200px;\n  height: 120px;\n  margin: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
